export default __webpack_public_path__ + "static/media/Download.4c502f6f.svg";